import { decodeCp1251 } from "../../../../lib/pn/cp1251.js";
import { parseDeclaration, parseD1, parseD2 } from "../../../../lib/vat/parse.js";
import { vatDeclarationHtml, vatD1Html, vatD2Html } from "../../../../lib/vat/form.js";
import formCssUrl from "../../../../lib/vat/form.css?url";
import ReportSign, { b64ToBytes } from "../ReportSign.jsx";

// Підпис і подання декларації з ПДВ (декларація + додатки) — спільний потік ReportSign; тут лише бланки з байтів ДПС
const ym = (y, m) => `${y}-${String(m).padStart(2, "0")}`;

// Бланк із байтів ДПС: розбираємо XML, який кабінет дає на підпис
function fromDps(sub, period) {
  const xml = Object.fromEntries(sub.docs.map((d) => [d.kind, decodeCp1251(b64ToBytes(d.dpsXml))]));
  const decl = parseDeclaration(xml.decl);
  const d1 = xml.d1 ? parseD1(xml.d1) : { t11: [], t21: [], t22: [] };
  const res = { period, rows: decl.rows,
    d1: { t11: d1.t11, t21: d1.t21.map((r) => ({ supplier: r.supplier, ym: ym(r.year, r.month), rate: r.vat7 ? 7 : r.vat14 ? 14 : 20, base: r.base, vat: r.vat })),
      t22: d1.t22.map((r) => ({ supplier: r.supplier, ym: ym(r.rkYear, r.rkMonth), pnYm: r.pnYear ? ym(r.pnYear, r.pnMonth) : null, rate: 20, base: r.base, vat: r.vat })) },
    d2: xml.d2 ? parseD2(xml.d2) : null };
  return { res, org: decl.org, xml };
}

export default function VatSign({ companyId, company, draftId, period, onRelogin, version }) {
  const blanks = (sub) => {
    const b = fromDps(sub, period), cssHref = new URL(formCssUrl, location.href).href;
    const tabs = [{ key: "decl", label: "Декларація", html: vatDeclarationHtml({ org: b.org, decl: b.res, hasD1: Boolean(b.xml.d1), hasD2: Boolean(b.xml.d2), cssHref }) },
      ...(b.xml.d1 ? [{ key: "d1", label: "Додаток 1", html: vatD1Html({ org: b.org, decl: b.res, cssHref }) }] : []),
      ...(b.xml.d2 ? [{ key: "d2", label: "Додаток 2", html: vatD2Html({ org: b.org, decl: b.res, cssHref }) }] : [])];
    return { tabs, signer: { kbos: b.org?.kbos, bos: b.org?.bos } };
  };
  return <ReportSign companyId={companyId} company={company} draftId={draftId} apiKey="vat" blanks={blanks} what="декларацію" onRelogin={onRelogin} version={version} />;
}
